import type { ActionFunctionArgs, LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { json, redirect, useLoaderData } from "@remix-run/react";
import { Buffer } from 'node:buffer';
import { FacebookShareButton, LinkedinShareButton, PinterestShareButton, TwitterShareButton } from "react-share";
import Container from "~/components/layout/Container";
import { Icon } from "~/components/ui/icon";
import { getValidatedFormData } from "~/lib/remix-hook-form";
import { transpileText } from "~/utils/transpileText";
import { siteTitle } from "../../_index";
import References from "../../features/References";
import { Services } from "../../features/Services";
import Slogans from "../../features/Slogans";
import ContactForm from "../features/Form";
import { servicesData } from "../features/hizmetlerData";
import { type hizmetFormFormSchemaType, hizmetFormResolver } from "./features/contact.schemas";

export const loader = ({ params }: LoaderFunctionArgs) => {
  const title = transpileText("Başarının gelecekte yattığını bilerek, teknolojiyi yakından takip ediyor ve üretici firmalarla güçlü ortaklıklar kuruyoruz. Sektördeki tüm yenilikleri ve değişimleri izleyerek, iş ortaklarımız için hem ihracatta hem ithalatta kapsamlı pazar araştırmalar yapıp müşteri bilgileri sağlayabiliyor, muhtelif konularda yapılan eğitimler ile iş ortaklarımızın gelişimine yardımcı oluyoruz.");
  const serviceData = servicesData.find((service) => service.id === params.id);
  if (!serviceData) {
    return redirect("/hizmetlerimiz");
  }
  serviceData.description = transpileText(serviceData.description);
  const serviceDataWithTranspiledDetails = { ...serviceData, detailsList: serviceData?.detailsList?.map((detail: string) => transpileText(detail)) };
  const serviceDataWithTranspiledDetailsAndTags = { ...serviceDataWithTranspiledDetails, tags: serviceDataWithTranspiledDetails?.tags?.map((tag: string) => transpileText(tag)) };
  return { servicesData, serviceData: serviceDataWithTranspiledDetailsAndTags, title };
};
export async function action({ request }: ActionFunctionArgs) {
  console.log('hizmetlerimiz formu gonderildi')


  const { errors, data } = await getValidatedFormData<hizmetFormFormSchemaType>(request, hizmetFormResolver)
  console.log('data', data)
  if (errors) {
    return json({
      success: false,
      data: 'hata',
    })
  }
  const html = `
    <h1>Hizmetlerimiz Formu</h1>
    <p>Firma Adı: ${data?.firmaAdi}</p>
    <p>Ad Soyad: ${data?.adSoyad}</p>
    <p>Telefon: ${data?.telefon}</p>
    <p>Konu: ${data?.konu}</p>
    <p>Email: ${data?.email}</p>
    <p>Hizmetler: ${data?.hizmetler}</p>
    <p>Mesaj: ${data?.mesaj}</p>
    `
  const frmdata = new FormData();
  frmdata.append("from", 'UTBSupport hizmetlerimiz formu <mail@utbsupport.com>');
  frmdata.append("to", 'safakbekir@yandex.com');
  frmdata.append("subject", "Hizmetlerimiz Formu");
  frmdata.append("text", "Hizmetlerimiz Formu");
  frmdata.append("html", html);

  console.log('mailgun frmdata', Object.fromEntries(frmdata.entries()))

  let result = false
  const auth = `Basic ${Buffer.from(
    'api:9e57433c0a82d5320d472b6f82abfeea-f3238714-56b523ca',
  ).toString('base64')}`

  console.log('mailgun auth')

  const results = await fetch('https://api.eu.mailgun.net/v3/mail.utbsupport.com/messages', {
    method: 'post',
    headers: {
      Authorization: auth
    },
    body: frmdata
  })
    .then((response) => {
      console.log('mailgun response', response)
      return response.json() as Promise<{ id?: string, message?: string }>
    })
    .then((sonuc) => {
      console.log('mailgun sonuc aldim', sonuc)
      if (sonuc?.id) {
        result = true
        return json({
          success: true,
          data: 'basarili',
        })
      }
      result = false
      return json({
        success: false,
        data: 'basarisiz',
      })
    })
    .catch((error) => {
      console.log('mailgun hata', Object.fromEntries(error))
      return json({
        success: false,
        data: 'hata',
      })
    })
  console.log('mailgun sonuc', result)
  return json({
    success: result,
    data: result ? 'basarili' : 'basarisiz',
  })
}
export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return [{
    title: `${data?.serviceData?.title} | Hizmetler | UTB Trader & Support | UTB Support Hizmetleri | ${siteTitle}`,
  }]
}
export default function HizmetDetay() {
  const { servicesData, serviceData, title } = useLoaderData<typeof loader>();
  // TODO: font turkce olarak degistir
  return (
    <div className="pt-[122px]">
      <div className="bg-[#ffffff]">
        <div className="header bg-[#efefef]">
          <Container>
            <h1 className="font-raleway uppercase text-[28px] py-12 w-full font-bold">Hizmetlerimiz</h1>
          </Container>
        </div>
        <Container className="flex-wrap">
          <p className="text-center text-[24px] mb-12 font-lato text-[#444444] relative font-[300] py-12 after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:m-auto after:w-20 after:h-0.5 after:bg-[#20b1d7] [&_i]:font-thin [&_i]:not-italic [&_i]:font-lato" dangerouslySetInnerHTML={{ __html: title }} />
          <div className="flex justify-start items-start flex-wrap">
            <h3 className="text-xl font-black font-raleway w-full text-[22px] text-[#16437c] mb-8">{serviceData?.title}</h3>
            <div className=" w-full [&_div:nth-child(3)]:!font-semibold [&_div:nth-child(3)_i]:font-normal [&_div:nth-child(3)_i]:not-italic">
              <img src={serviceData?.image} alt={serviceData?.title} className="group-hover:shadow-lg md:w-7/12 object-cover md:float-left pb-8 pr-8" />
              <div className="mb-4 font-medium text-[16px] font-crete-round md:w-5/12 h-auto object-cover relative text-[#555555] italic border-l-6 border-l-[#ededed] md:float-right py-2 pl-6" dangerouslySetInnerHTML={{ __html: serviceData?.description }} />
              {serviceData?.detailsList && serviceData?.detailsList.length > 0 && serviceData?.detailsList?.map((detail: string) => (
                <div key={detail} className="text-[16px] font-lato text-[#333333] mb-7 [&_p]:!my-2 [&_p]:!font-normal [&_i]:not-italic [&_strong]:!font-bold [&_strong]:not-italic [&_strong]:block [&_strong]:mt-4 !font-normal [&_*]:!font-normal [&_ul]:!list-disc [&_ul]:!list-inside" dangerouslySetInnerHTML={{ __html: detail }} />
              ))}
            </div>
          </div>
          <div className="flex flex-wrap">
            {serviceData?.tags && serviceData?.tags.length > 0 && serviceData?.tags?.map((tag: string) => (
              <span key={tag} className="text-[14px] font-lato text-[#333333] mb-7 [&_i]:not-italic py-1 px-2 border border-[#dedede] mr-2 font-medium" dangerouslySetInnerHTML={{ __html: `#${tag}` }} />
            ))}
          </div>
          <div className="flex justify-between items-center w-full border-b pt-8 pb-8 md:flex-wrap">
            <h6 className="text-[16px] font-lato text-[#333333]">Bu Hizmeti Paylaşabilirsiniz:</h6>
            <div className="flex gap-4">
              <FacebookShareButton url={`https://utbsupport.com/hizmetlerimiz/detay/${serviceData?.id}`}>
                <Icon name="bx:bxl-facebook" size="md" />
              </FacebookShareButton>
              <TwitterShareButton url={`https://utbsupport.com/hizmetlerimiz/detay/${serviceData?.id}`}>
                <Icon name="hugeicons:new-twitter" size="md" />
              </TwitterShareButton>
              <PinterestShareButton url={`https://utbsupport.com/hizmetlerimiz/detay/${serviceData?.id}`} media={`https://utbsupport.com/${serviceData?.image}`}>
                <Icon name="bx:bxl-pinterest-alt" size="md" />
              </PinterestShareButton>
              <LinkedinShareButton url={`https://utbsupport.com/hizmetlerimiz/detay/${serviceData?.id}`}>
                <Icon name="akar-icons:linkedin-v2-fill" size="md" />
              </LinkedinShareButton>
            </div>
          </div>
          <div className="[&_#hizmetlerimiz_h2]:text-left [&_#hizmetlerimiz_h2]:!font-bold [&_#hizmetlerimiz_h2]:!text-[28px] [&_#hizmetlerimiz>div>p]:hidden">
            <Services hizmetler={servicesData} header={'Diğer Hizmet Başlıkları'} />
          </div>
          <ContactForm services={servicesData} />
        </Container>
      </div>
      <Slogans />
      <References />
    </div>
  )
}
